export default __webpack_public_path__ + "static/media/logo.59199ca0.svg";